import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { SectionLabel, Reveal } from "./Section";
import ImgFagnerPerfil from '../assets/sobre/perfil-fagner-3.png'

export const About = ({ t }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="about" ref={ref} className="relative py-28 md:py-40 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <SectionLabel num={t.about.num} label={t.about.label} id="about" />

        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Left: portrait with parallax */}
          <div className="lg:col-span-5">
            <Reveal>
              <div className="relative rounded-2xl overflow-hidden border border-[#1a1d27] aspect-[4/5] max-w-md">
                <motion.img
                  style={{ y }}
                  src={ImgFagnerPerfil}
                  alt="Fagner developing"
                  className="absolute inset-0 w-full h-[124%] object-cover -top-[12%] grayscale-[0.1] contrast-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050608] via-transparent to-transparent" />
                <div className="absolute inset-0 bg-[#2563eb]/10 mix-blend-color" />
              </div>
            </Reveal>
          </div>

          {/* Right: text */}
          <div className="lg:col-span-7 lg:pt-6">
            <Reveal delay={0.1}>
              <h2 className="font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-[1.05] max-w-2xl">
                {t.about.title}
              </h2>
            </Reveal>

            <div className="mt-8 space-y-5 max-w-xl text-[#8b95a5] leading-relaxed">
              <Reveal delay={0.15}><p>{t.about.p1}</p></Reveal>
              <Reveal delay={0.2}><p>{t.about.p2}</p></Reveal>
              <Reveal delay={0.2}><p>{t.about.p3}</p></Reveal>
            </div>

            <Reveal delay={0.25}>
              <div className="mt-12 grid grid-cols-3 gap-4 max-w-xl">
                {t.about.stats.map((s) => (
                  <div key={s.label} className="border-l border-[#1a1d27] pl-4">
                    <div className="font-display font-extrabold text-3xl md:text-4xl text-white">{s.value}</div>
                    <div className="font-mono text-[11px] text-[#8b95a5] mt-1 leading-tight">{s.label}</div>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
